<template>
  <b-modal
    id="contact-tag-delete-modal"
    ref="contactTagDeleteModal"
    modal-class="delete-modal"
    size="sm">
    <div class="text-center">
      <h5>Are you sure you want to delete this tag?</h5>
    </div>
    <template slot="modal-footer">
      <b-button @click="hide">
        Close
      </b-button>
      <b-button
        :disabled="deleting"
        @click="commitDelete">
        Yes
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ContactTagDeleteModal',
  props: {
    tagp: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      deleting: false,
    };
  },
  computed: {
    ...mapGetters({
      contactTagDeleted: 'contact/contactTagDeleted',
      apiError: 'contact/apiError',
    }),
  },
  watch: {
    contactTagDeleted(deleted) {
      if (deleted) {
        this.$emit('deleted', deleted);
        this.hide();
      }
    },
  },
  methods: {
    ...mapActions({
      deleteContactTag: 'contact/deleteContactTag',
    }),
    commitDelete() {
      this.deleting = true;
      this.deleteContactTag({
        merchant_id: this.$route.params.merchant_id,
        tag_id: this.tagp.id,
      });
    },
    show() {
      this.$refs.contactTagDeleteModal.show();
    },
    hide() {
      this.deleting = false;
      this.$refs.contactTagDeleteModal.hide();
    },
  },
};
</script>
